import axios from 'axios'

import config from '../../config'

const createInspectionSubtype = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/InspectionSubtypes`
  return axios.post(url, data)
}

export default createInspectionSubtype
